import { FontColorEnum, FontSizeEnum, FontWeightEnum, Typography } from '@acceso/design-system';
import { useMemo } from 'react';

import { formatDate } from '@/helpers/format-date';

type TStartTimeEndTimePartProps = {
  startDateTime?: string;
  endDateTime?: string;
  showEndDatePart?: boolean;
};

export function StartTimeEndTimePart({
  startDateTime,
  endDateTime,
  showEndDatePart = true,
}: TStartTimeEndTimePartProps) {
  const { datePart, timePart } = useMemo(() => {
    if (!startDateTime) return { datePart: '', timePart: '' };
    return formatDate(startDateTime);
  }, [startDateTime]);
  const { datePart: endDatePart, timePart: endTimePart } = useMemo(() => {
    if (!endDateTime) return { datePart: '', timePart: '' };
    return formatDate(endDateTime);
  }, [endDateTime]);

  return (
    <div className="flex items-center gap-1">
      {datePart && (
        <>
          <Typography
            fontSize={FontSizeEnum.Xs}
            color={FontColorEnum.Medium}
            weight={FontWeightEnum.Semibold}
          >
            {datePart}
          </Typography>
        </>
      )}
      {timePart && (
        <Typography
          fontSize={FontSizeEnum.Xs}
          color={FontColorEnum.Medium}
          weight={FontWeightEnum.Regular}
        >
          {timePart}
        </Typography>
      )}
      {showEndDatePart && endDatePart && (
        <>
          <span>-</span>
          <Typography
            fontSize={FontSizeEnum.Xs}
            color={FontColorEnum.Medium}
            weight={FontWeightEnum.Semibold}
          >
            {endDatePart}
          </Typography>
          <Typography
            fontSize={FontSizeEnum.Xs}
            color={FontColorEnum.Medium}
            weight={FontWeightEnum.Semibold}
          >
            -
          </Typography>
        </>
      )}
      {endTimePart && (
        <>
          {!showEndDatePart && <span>-</span>}
          <Typography
            fontSize={FontSizeEnum.Xs}
            color={FontColorEnum.Medium}
            weight={FontWeightEnum.Regular}
          >
            {endTimePart}
          </Typography>
        </>
      )}
    </div>
  );
}
